/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  SignInWithApple,
  SignInWithAppleOptions,
} from '@iwarranty-io/apple-sign-in';
import { Capacitor } from '@capacitor/core';
import { hashCode } from 'app/tools/utils';
import { FacebookLogin } from '@iwarranty-io/facebook-login';
import { GoogleAuth } from '@iwarranty-io/capacitor-google-auth';
import { ExternalSignInReq } from './api-auth.types';

const getNonce = (): string =>
  hashCode(Date.now().toString()).toFixed(0);

// will be com.iwarranty.app on iOS, com.iwarranty.app.web otherwise
const appleClientId = `com.iwarranty.app${
  Capacitor.getPlatform() === 'ios' ? '' : '.web'
}`;
const appleSignInOptions: (
  nonce: string
) => SignInWithAppleOptions = nonce => ({
  clientId: appleClientId,
  redirectURI: window.location.toString(),
  scopes: 'email name',
  nonce,
});

export const appleSignIn = (): Promise<ExternalSignInReq> => {
  const nonce = getNonce();
  return SignInWithApple.authorize(appleSignInOptions(nonce)).then(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (res: any) =>
      ({
        email: res.response.email ?? ' ',
        givenName: res.response.givenName ?? ' ',
        identityToken:
          res.response.identityToken ??
          res.response.accessToken ??
          res.response.deviceToken,
        role: 'user',
        source: 'apple',
        familyName: res.response.familyName ?? ' ',
      } as ExternalSignInReq)
  );
};

GoogleAuth.initialize({
  clientId:
    '476734743458-kkhm72np4oobufjoad9s2bnssjemkuli.apps.googleusercontent.com',
  scopes: ['profile', 'email'],
  grantOfflineAccess: true,
});

export const googleSignIn = async (): Promise<ExternalSignInReq> => {
  const response = await GoogleAuth.signIn();
  return {
    email: response.email,
    givenName: response.givenName,
    identityToken: response.authentication.idToken,
    role: 'user',
    source: 'google',
    familyName: response.familyName,
  } as ExternalSignInReq;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const initializeFacebookSignIn = async () => {
  await FacebookLogin.initialize({ appId: '487108966486547' });
};

export const facebookSignIn =
  async (): Promise<ExternalSignInReq> => {
    const FACEBOOK_PERMISSIONS = [
      'email',
      'user_birthday',
      'user_photos',
      'user_gender',
    ];
    const response = await FacebookLogin.login({
      permissions: FACEBOOK_PERMISSIONS,
    });
    const res = response;
    const { accessToken } = res;
    if (accessToken) {
      const profileData = await FacebookLogin.getProfile<{
        email: string;
        first_name: string;
        last_name: string;
      }>({ fields: ['email', 'first_name', 'last_name'] });
      return {
        email: profileData.email,
        givenName: profileData.first_name,
        identityToken: accessToken.token,
        role: 'user',
        source: 'facebook',
        familyName: profileData.last_name,
      } as ExternalSignInReq;
    } else {
      throw new Error('Not logged in');
    }
  };
